export const routes = {
    "/termsofservice":{component:"components/CneNurse/site/TermsOfUse"},
    "/privacypolicy":{component:"components/CneNurse/site/PrivacyPolicy"},
    "/termsandconditions":{component:"components/CneNurse/site/TermsAndConditions"},
    "/paymentsuccessful":{component:"components/CneNurse/site/PaymentSuccessful"}
};
